// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { BatchProcessesSubscriptions } from '../../../../types/server/modules/batchProcesses/subscriptions';

export type * from '../../../../types/server/modules/batchProcesses/subscriptions';

export const createSubscriptions = ( requests: Requests ): BatchProcessesSubscriptions => ({
  BatchProcessesProgress: ( params, onChange ) => {
          return requests.subscribe( `/batch-processes/progress/:batchProcessId?`, params, 'BatchProcessesProgress', onChange );
          },
  BatchProcessesProgressCount: ( params, onChange ) => {
          return requests.subscribe( `/batch-processes/progress-count/:batchProcessId`, params, 'BatchProcessesProgressCount', onChange );
          },
  BatchProcesses: ( params, onChange ) => {
          return requests.subscribe( `/batch-processes/:id?`, params, 'BatchProcesses', onChange );
          }
});
